import React from 'react';

import { Error403Box } from 'components/error-handle/errors/error-403-box';
import { getNewRelicAgent } from 'newRelicAgent';

export const Error403Page = ({ error }) => {
  if (error) {
    getNewRelicAgent().noticeError(error);
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <Error403Box />
        </div>
      </div>
    </div>
  );
};
